import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen } from 'lucide-react';
import { adminApi } from '../services/api.jsx';
import EtatVide from './EtatVide';
import ListeDocuments from './documents/ListeDocuments';
import { EtatErreur, SqueletteListe } from '../etats';

/* ═══════════════════════════════════════════════════════════════════════
   LES DOCUMENTS D'UNE ORGANISATION, SUR SA FICHE

   Pour lire une pièce déposée, il fallait : la liste des organisations,
   la fiche, revenir aux projets, retrouver le bon, l'ouvrir, puis son
   onglet « Documents ». Ici, tout ce qu'elle a déposé, tous dossiers
   confondus, avec l'aperçu et la décision sur place.

   Le serveur reste seul juge : il ne renvoie que les documents des
   projets que la personne connectée peut voir.
   ═══════════════════════════════════════════════════════════════════════ */

export default function DocumentsOrganisation({ organisationId }) {
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState(null);

  const charger = useCallback(async () => {
    setErreur('');
    try {
      const data = await adminApi.getDocumentsOrganisation(organisationId);
      setDocuments(Array.isArray(data) ? data : []);
    } catch (e) {
      setErreur(e);
    } finally {
      setChargement(false);
    }
  }, [organisationId]);

  useEffect(() => { if (organisationId) charger(); }, [organisationId, charger]);

  const aExaminer = documents.filter((d) => d.statut === 'soumis').length;

  return (
    <section className="shrink-0">
      <h2 className="titre-carte flex items-center gap-2 mb-3">
        <FolderOpen className="w-4 h-4 text-[var(--accent-texte)]" />
        Documents de l'organisation
        <span className="text-[13px] font-medium text-[var(--text-muted)]">
          {documents.length}{aExaminer > 0 ? ` · ${aExaminer} à examiner` : ''}
        </span>
      </h2>

      {chargement ? (
        <SqueletteListe lignes={3} />
      ) : erreur && !documents.length ? (
        <div className="bg-[var(--bg-card)] shadow-carte rounded-carte"><EtatErreur erreur={erreur} onReessayer={charger} /></div>
      ) : (
        <ListeDocuments
          documents={documents}
          peutExaminer
          onChange={charger}
          onOuvrirProjet={(doc) => navigate(`/projets/${doc.projet}?onglet=documents`)}
          vide={(
            <div className="bg-[var(--bg-card)] shadow-carte rounded-carte p-6">
              <EtatVide icone={FolderOpen} titre="Aucun document déposé"
                        aide="Les pièces que l'organisation dépose depuis son espace apparaîtront ici." />
            </div>
          )}
        />
      )}
    </section>
  );
}
